import { CurrencySchema } from '@eigtech/currency';
import { DocumentCornSchema } from '@eigtech/documents-types';
import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { StatusSchema } from './status.js';
export const InvoicingTypeSchema = z.enum(['bill', 'invoice']);
export const InvoicingTypeEnum = InvoicingTypeSchema.enum;
export const BaseInvoicingSchema = z.object({
    type: InvoicingTypeSchema,
    id: z.string(),
    entityId: CornSchema,
    status: StatusSchema,
    balance: CurrencySchema.optional(),
    documentId: DocumentCornSchema.optional(),
    additional: z.record(z.string(), z.unknown()).optional(),
    createdDate: z.string().date(),
});
